/* eslint-disable @typescript-eslint/no-floating-promises */

'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { CheckoutSkeleton } from 'components/ui/organisms/checkout/skeletons';
import { usePrepareCart } from 'frontastic/hooks';

export const AddToCartTastic = () => {
  const { prepareCartForCourses, prepareCartForProgram } = usePrepareCart();
  const searchParams = useSearchParams();
  const courseRunKeys = searchParams.getAll('course_run_key');
  const skus = searchParams.getAll('sku');
  const programId = searchParams.get('bundle');
  const discountCode = searchParams.get('code')?.toLocaleUpperCase();

  useEffect(() => {
    if (programId) {
      prepareCartForProgram(programId, skus, discountCode);
    } else {
      prepareCartForCourses(courseRunKeys, skus, discountCode);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <CheckoutSkeleton />;
};
